import { render } from "./SbmReport.vue?vue&type=template&id=1dacbbf4&scoped=true"
import script from "./SbmReport.vue?vue&type=script&lang=js"
export * from "./SbmReport.vue?vue&type=script&lang=js"

import "./SbmReport.vue?vue&type=style&index=0&id=1dacbbf4&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\MSRTC\\MSRTC-CODE\\ui-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dacbbf4"]])

export default __exports__